/**
 * TanStack Query hooks for `agency-dashboard-aggregating-all-client-performanc`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	agencyDashboardAggregatingAllClientPerformancQueryKeys,
	type CreateAgencyDashboardAggregatingAllClientPerformancBody,
	type ListAgencyDashboardAggregatingAllClientPerformancResponse,
	type AgencyDashboardAggregatingAllClientPerformancRow,
} from "./api";

export function useAgencyDashboardAggregatingAllClientPerformancList(): UseQueryResult<ListAgencyDashboardAggregatingAllClientPerformancResponse, Error> {
	return useQuery({
		queryKey: agencyDashboardAggregatingAllClientPerformancQueryKeys.list(),
		queryFn: list,
	});
}

export function useAgencyDashboardAggregatingAllClientPerformancCreate(): UseMutationResult<AgencyDashboardAggregatingAllClientPerformancRow, Error, CreateAgencyDashboardAggregatingAllClientPerformancBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: agencyDashboardAggregatingAllClientPerformancQueryKeys.all });
		},
	});
}

export function useAgencyDashboardAggregatingAllClientPerformancDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: agencyDashboardAggregatingAllClientPerformancQueryKeys.all });
		},
	});
}
